export interface LieferantenFacetSearchData extends LieferantenSearchData {
  searchWord: string;
  chipDataString: string;
  // need all fields from SearchData for proper filtering and correct count numbers
}

export interface LieferantenSearchData {
  zrNumbersId: string[];
  statusCompanies: string[];
  companiesWrGruppen: string[];
  searchFacetFields: Array<any>;
  chipDataString?: string;
  email: string;
}

function defaultData(): LieferantenSearchData {
  return {
    zrNumbersId: [],
    statusCompanies: [],
    companiesWrGruppen: [],
    searchFacetFields: [],
    email: '',
  };
}

export default {
  defaultData,
};
